import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'timeBetweenDates'
})
export class TimeBetweenDatesPipe implements PipeTransform {
    transform(start: Date | number, end: Date | number): string {
        if (!start || !end) {
            throw new Error('Requires a Date as input');
        }
        start = new Date(start);
        end = new Date(end);
        if (!start || typeof start.getMonth !== 'function' || !end || typeof end.getMonth !== 'function') {
            throw new Error('Requires a Date as input');
        }
        if (start > end) {
            throw new Error('Start must be before end');
        }

        let seconds = 0;
        if (end.getTime() < start.getTime()) {
            seconds = 86400 - start.getTime() / 1000 + end.getTime() / 1000; // end time is next day
        } else {
            seconds = (end.getTime() - start.getTime()) / 1000;
        }
        const hours = Math.floor(seconds / 60 / 60);
        const minutes = Math.floor(seconds / 60 - hours * 60);
        if (hours === 0) {
            return String(minutes) + ' min';
        }
        return String(hours) + 'h ' + String(minutes) + ' min';
    }
}
